import { z } from "zod";

import { FRIENDS_METRICS } from "./FRIENDS_METRICS";
import { FRIENDS_PERIODS } from "./FRIENDS_PERIODS";

// Search params экрана: `/friends?period=week&metric=kda`. Нет параметра или неверное
// значение — по умолчанию (месяц, общая оценка).
export const friendsSearchSchema = z.object({
  period: z.enum(FRIENDS_PERIODS).optional().catch(undefined),
  metric: z.enum(FRIENDS_METRICS).optional().catch(undefined),
});

export type FriendsSearch = z.infer<typeof friendsSearchSchema>;
